import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import SoftphoneLine, {
  SoftphoneLineForm,
  UpdateSoftphoneLineForm,
} from "@/interfaces/SoftphoneLine";
import api from "./api";

export const softphoneLinesApi = api.injectEndpoints({
  endpoints: (builds) => ({
    getSoftphoneLines: builds.query<IPaginateResponse<SoftphoneLine>, IFilters>(
      {
        query: (params) => ({
          url: "/softphone-lines",
          params,
        }),
        providesTags: (result) =>
          result
            ? [
                ...result.data.map(({ id }) => ({
                  type: "SoftphoneLines" as const,
                  id,
                })),
                { type: "SoftphoneLines", id: "LIST" },
              ]
            : [{ type: "SoftphoneLines", id: "LIST" }],
      },
    ),
    storeSoftphoneLine: builds.mutation<SoftphoneLine, SoftphoneLineForm>({
      query: (data) => ({
        url: "/softphone-lines",
        method: "POST",
        body: data,
        headers:
          data.userIds !== undefined
            ? { "X-Softphone-Protocol": "2" }
            : undefined,
      }),
      invalidatesTags: [{ type: "SoftphoneLines", id: "LIST" }],
    }),
    updateSoftphoneLine: builds.mutation<
      SoftphoneLine,
      { id: string; data: UpdateSoftphoneLineForm }
    >({
      query: ({ id, data }) => ({
        url: `/softphone-lines/${id}`,
        method: "PUT",
        body: data,
        headers:
          data.userIds !== undefined
            ? { "X-Softphone-Protocol": "2" }
            : undefined,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "SoftphoneLines", id },
        { type: "SoftphoneLines", id: "LIST" },
      ],
    }),
    deleteSoftphoneLine: builds.mutation<void, string>({
      query: (id) => ({
        url: `/softphone-lines/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "SoftphoneLines", id: "LIST" }],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetSoftphoneLinesQuery,
  useStoreSoftphoneLineMutation,
  useUpdateSoftphoneLineMutation,
  useDeleteSoftphoneLineMutation,
} = softphoneLinesApi;
